import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { kitContents } from '../data/kitContents';
import { tomes } from '../data/tomes';
export function KitContentsSection() {
  return <section aria-labelledby="kit-title" className="bg-white px-4 py-20 md:py-28" data-id="element-168" data-mp="2577hbb2clodb">
      <Reveal className="mx-auto max-w-6xl" data-id="element-169" data-mp="2a7v9w1686d9n">
        <div className="mb-12 text-center" data-id="element-170" data-mp="2a8n5hbztoazx">
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal-ink" data-id="element-171" data-mp="2f6ydriagydg1">
            LE CONTENU DE LA COLLECTION
          </p>
          <h2 id="kit-title" className="text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-172" data-mp="2j6738ayh7p5s">
            Que contient MUSIQUE PRÊTE&nbsp;?
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-173" data-mp="2sxblpknd1s5d">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-2xl border border-brand-line bg-brand-ivory p-7 text-center" data-id="element-174" data-mp="2xv3d8dk3fc91">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-teal" strokeWidth={1.5} aria-hidden="true" data-id="element-175" data-mp="10n72kpvyk8fs" />
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-navy" data-id="element-176" data-mp="vl80djbyfhkf">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-177" data-mp="qnq0sjjtuep3">{description}</p>
            </article>)}
        </div>

        <div className="mt-16 rounded-3xl border border-brand-line bg-brand-ivory px-5 py-8 md:px-10 md:py-10" data-id="element-178" data-mp="1jc3w2rjj6wwy">
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between md:gap-8" data-id="element-179" data-mp="1ecioxtu7ji95">
            <h3 id="tomes-title" className="max-w-2xl text-2xl font-extrabold leading-tight tracking-tight text-brand-navy md:text-3xl" data-id="element-180" data-mp="19lsgu8ued1ar">
              10 tomes pour accompagner la progression de vos élèves
            </h3>
            <p className="shrink-0 text-sm font-semibold text-slate-600" data-id="element-181" data-mp="224fzzipu2697">10 × 60 pages</p>
          </div>
          <ol aria-labelledby="tomes-title" className="mt-8 grid md:grid-flow-col md:grid-cols-2 md:grid-rows-5 md:gap-x-10" data-id="element-182" data-mp="1xa1yqzohp4wm">
            {tomes.map(({
            title,
            description,
            pages
          }, index) => <li key={title} className="flex items-start gap-4 border-t border-brand-line py-4" data-id="element-183" data-mp="3hugtlwe4ky95" data-mpi={index}>
                <span className="w-7 shrink-0 pt-0.5 text-sm font-extrabold tabular-nums text-brand-teal-ink" data-id="element-184" data-mp="3msihcumhxlqy">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="min-w-0 flex-1" data-id="element-185" data-mp="3ds2arcaghyhv">
                  <p className="font-bold leading-snug text-brand-navy" data-id="element-186" data-mp="3dtn8fas2hxjy">{title}</p>
                  <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-187" data-mp="2ywcy44r5uxpt">{description}</p>
                </div>
                <span className="shrink-0 whitespace-nowrap pt-0.5 text-xs font-semibold text-slate-600" data-id="element-188" data-mp="33uehyrwev12c">
                  {pages} pages
                </span>
              </li>)}
          </ol>
          <p className="mt-4 border-t border-brand-line pt-6 text-sm leading-relaxed text-slate-600" data-id="element-189" data-mp="121zznrpyfule">
            Choisissez les tomes selon les acquis de vos élèves. Cette collection internationale est à adapter à votre
            contexte et au programme de votre pays.
          </p>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-190" data-mp="2wcq34oa7ylb5">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-191" data-mp="2rjn5a3yespp5" />
        </div>
      </Reveal>
    </section>;
}